import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PageNotFound from "AppComponents/PageNotFound";

export default () => ({
  path: "page-not-found",
  component: withAsyncRouteLoading(
    () =>
      new Promise((cb, reject) => {
        require.ensure(
          [],
          () => {
            cb(PageNotFound);
          },
          err => {
            reject(err);
          }
        );
      })
  ),
  childRoutes: [],
});
